import { get } from 'lodash';
import { ExportFileFormat } from '../../../export-task.enum';
import { ProcessorPropertyCommonTypes } from '../processor-types.enums';
import { ExportPropertyTypeTransformParams } from '../processor-types.interface';

export const number = (target: string | number): ExportPropertyTypeTransformParams => ({
  __for_processor: true,
  formats: [ExportFileFormat.Excel, ExportFileFormat.JSON, ExportFileFormat.CSV],
  type: ProcessorPropertyCommonTypes.Number,
  transform: () => {
    const num = Number(target);
    if (isNaN(num)) return null;
    return num;
  },
  fallback: target,
});

export const boolean = (
  target: string | number | boolean,
  options?: { trueText?: string, falseText?: string },
): ExportPropertyTypeTransformParams => ({
  __for_processor: true,
  formats: [ExportFileFormat.Excel, ExportFileFormat.JSON, ExportFileFormat.CSV],
  type: ProcessorPropertyCommonTypes.Boolean,
  transform: () => {
    const trueText = get(options, 'trueText', 'Si');
    const falseText = get(options, 'falseText', 'No');
    if (typeof target === 'string') {
      if (target === 'true') return trueText;
      if (target === 'false') return falseText;
      return null;
    }
    if (typeof target === 'number') {
      if (target === 1) return trueText;
      if (target === 0) return falseText;
      return null;
    }
    if (typeof target === 'boolean') {
      return target ? trueText : falseText;
    }
    return null;
  },
  fallback: target,
});
